import axios from 'axios';
import Errors from './Errors';

export default {
  data() {
    return {
      baseUrl: '',
      userId: null,
    };
  },
  async get(id) {
    try {
      const { data } = await axios.get(`${this.baseUrl}People/${id}`);
      return [null, data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async getPerson(domain, login) {
    try {
      const { data } = await axios.get(`${this.baseUrl}People/${domain}/${login}`);
      return [null, data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async createPerson(domain, login, volunteer) {
    try {
      const { data } = await axios.get(`${this.baseUrl}People/Create/${domain}/${login}/${volunteer}`);
      return [null, data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async getPersonEntities(id) {
    try {
      const { data } = await axios.get(`${this.baseUrl}People/${id}/Entities`);
      return [null, data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async getPeople() {
    try {
      const { data } = await axios.get(`${this.baseUrl}People`, {
        headers: {
          'Content-Type': 'application/json',
          'User-Id': this.userId,
        },
      });
      return [null, data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async getDashboard(id) {
    try {
      const { data } = await axios.get(`${this.baseUrl}People/${id}/dashboard`);
      return [null, data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async getAnnualTotals(personId, activityId) {
    try {
      const { data } = await axios.get(`${this.baseUrl}People/${personId}/AnnualTotals/Activity/${activityId}`);
      return [null, data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async putPerson(id, person) {
    try {
      const json = JSON.stringify(person);
      const data = await axios.put(`${this.baseUrl}People/${id}`, json, {
        headers: {
          'Content-Type': 'application/json',
          'User-Id': this.userId,
        },
      });
      return [null, data.data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async saveEntities(id, entities) {
    try {
      const data = await axios.put(`${this.baseUrl}People/${id}/Entities`, entities, {
        headers: {
          'Content-Type': 'application/json',
          'User-Id': this.userId,
        },
      });

      return data;
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async saveRoles(id, roles) {
    try {
      const data = await axios.put(`${this.baseUrl}People/${id}/Roles`, roles, {
        headers: {
          'Content-Type': 'application/json',
          'User-Id': this.userId,
        },
      });

      return data;
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
};
